<section class="bitwit-shell">
  <div class="bitwit-layout">
    <div class="bitwit-stage">
      <header class="bitwit-hero">
        <div>
          <p class="eyebrow">BitWit Copilot</p>
          <h1>What are you working on?</h1>
          <p class="lede">Blend RTA and bit intelligence, then hand the prompt to Foundry.</p>
        </div>
        <div class="hero-actions">
          <kendo-loader *ngIf="sending" [size]="'small'" [themeColor]="'info'"></kendo-loader>
        </div>
      </header>

    <form class="bitwit-form" [formGroup]="promptForm" (ngSubmit)="sendPrompt()">
      <div class="context-panel">
        <div>
          <label class="context-label" for="bitwit-context">Context focus</label>
          <p class="context-hint">Switch between RTA heavy, bit heavy, or a hybrid perspective.</p>
        </div>
        <kendo-dropdownlist
          id="bitwit-context"
          class="context-select"
          formControlName="contextType"
          [data]="contextOptions"
          textField="label"
          valueField="value"
          [valuePrimitive]="true"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            <div class="context-option">
              <div>{{ dataItem.label }}</div>
              <small>{{ dataItem.description }}</small>
            </div>
          </ng-template>
        </kendo-dropdownlist>
      </div>

      <div class="meta-row">
        <label>
          <span class="field-label">RTA #</span>
          <input kendoTextBox formControlName="rtaId" placeholder="E.g. RTA-148200" />
        </label>
        <label>
          <span class="field-label">Bit serial</span>
          <input kendoTextBox formControlName="bitSerial" placeholder="E.g. FC-19123" />
        </label>
        <label>
          <span class="field-label">Temp</span>
          <kendo-numerictextbox
            formControlName="temperature"
            [min]="0"
            [max]="1"
            [step]="0.05"
            format="n2"
          ></kendo-numerictextbox>
        </label>
        <label>
          <span class="field-label">Max tokens</span>
          <kendo-numerictextbox
            formControlName="maxTokens"
            [min]="64"
            [max]="4096"
            [step]="64"
          ></kendo-numerictextbox>
        </label>
        <label class="telemetry-toggle">
          <span>Telemetry</span>
          <kendo-switch formControlName="includeTelemetry"></kendo-switch>
        </label>
      </div>

      <div class="bitwit-input-bar">
        <button
          type="button"
          class="context-pill"
          [disabled]="!interactions.length"
          (click)="interactions.length && reusePrompt(interactions[interactions.length - 1])"
        >
          +
        </button>
        <textarea
          kendoTextArea
          id="bitwit-prompt"
          formControlName="prompt"
          rows="1"
          placeholder="Ask anything... summarize offsets, compare dull condition, prep the SAP payload."
        ></textarea>
        <button kendoButton [primary]="true" type="submit" [disabled]="sending" class="send-icon-button" fillMode="clear">
          <kendo-svgicon [icon]="paperPlaneIcon"></kendo-svgicon>
        </button>
      </div>
      <div
        class="validation"
        *ngIf="promptControl?.invalid && ((promptControl?.dirty ?? false) || (promptControl?.touched ?? false))"
      >
        Provide at least four characters so BitWit has something to reason about.
      </div>
      <div class="bitwit-error" *ngIf="lastError">
        {{ lastError }}
      </div>
    </form>
    </div>

    <div class="bitwit-chat">
      <div *ngIf="!interactions.length" class="empty-state">
        <p>Start typing above and your conversation will appear here.</p>
      </div>

      <article *ngFor="let interaction of interactions" class="message" [ngClass]="interaction.role">
        <header>
          <div class="label">
            <span class="role">{{ interaction.role === 'assistant' ? 'BitWit' : 'You' }}</span>
            <span class="timestamp">{{ interaction.timestamp | date: 'short' }}</span>
          </div>
          <span class="status" [ngClass]="interaction.status">{{ interaction.status }}</span>
        </header>
        <section class="content">
          <pre>{{ interaction.content }}</pre>
        </section>
        <footer>
          <div *ngIf="interaction.response?.diagnostics as diag" class="diagnostics">
            <span>Prompt tokens: {{ diag.tokensPrompt || '—' }}</span>
            <span>Completion tokens: {{ diag.tokensCompletion || '—' }}</span>
          </div>
          <button
            *ngIf="interaction.prompt"
            kendoButton
            look="flat"
            type="button"
            (click)="reusePrompt(interaction)"
          >
            Reuse prompt
          </button>
        </footer>
      </article>
    </div>
  </div>
</section>
